var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post"},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.posting.title)}}),_c('router-view',{staticClass:"posting-body"}),_c('router-link',{staticClass:"back",attrs:{"to":"/","tag":"a"}},[_vm._v("« Back")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }